import { render, staticRenderFns } from "./media-item.vue?vue&type=template&id=35dece58&scoped=true&"
import script from "./media-item.vue?vue&type=script&lang=js&"
export * from "./media-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dece58",
  null
  
)

export default component.exports